import axios from './../api' // 倒入 api

// 获取用车单列表
const getCarorderList = (data) => {
  return axios({
    url: '/api/carorder/list',
    method: 'POST',
    data,
  })
}
//获取用车审批列表
const getPrivateExamineList = (data) => {
  return axios({
    url: '/api/carorder/examine/private/list',
    method: 'POST',
    data,
  })
}
//获取私车公用列表
const getPrivateList = (data) => {
  return axios({
    url: '/api/carorder/private/list',
    method: 'POST',
    data,
  })
}
//获取私车信息列表
const getPersonPrivateCarList = (params) => {
  return axios({
    url: `/api/private/car/list`,
    params,
  })
}
//用车申请
const applyCarOrder = (data) => {
  return axios({
    url: '/api/order/apply',
    method: 'POST',
    data,
  })
}

//直接派车
const directTask = (data) => {
  return axios({
    url: '/api/task/direct',
    method: 'POST',
    data,
  })
}

//登记用车
const registerTask = (data) => {
  return axios({
    url: '/api/task/register',
    method: 'POST',
    data,
  })
}
//今日油价
const oilPrice = (params) => {
  return axios({
    url: '/api/oil-price',
    params,
  })
}
//派单处理
const handleDispatch = (carOrderId, data) => {
  return axios({
    url: `/api/task/${carOrderId}`,
    method: 'POST',
    data,
  })
}

//派单处理
const examineDispatch = (data) => {
  return axios({
    url: `/api/examine/dispatch`,
    method: 'POST',
    data,
  })
}

//用车单撤销
const orderRevoke = (data, carOrderId) => {
  return axios({
    url: `/api/carorder/cancel/${carOrderId}`,
    method: 'PUT',
    data,
  })
}

//用车单审核
const orderexamine = (data) => {
  return axios({
    url: `/api/examine`,
    method: 'POST',
    data,
  })
}
//车务审批
const carServiceCheck = (data) => {
  return axios({
    url: `/api/car-service/check`,
    method: 'POST',
    data,
  })
}

// /carorder/cancel/{carOrderId}
//获取可用车辆
const getTaskCars = (data) => {
  return axios({
    url: '/api/task/cars',
    method: 'POST',
    data,
  })
}

//获取可用车辆
const getTaskDrivers = (data) => {
  return axios({
    url: '/api/task/drivers',
    method: 'POST',
    data,
  })
}

//获取用车审核列表
const getExamineList = (data) => {
  return axios({
    url: '/api/carorder/examine/list',
    method: 'POST',
    data,
  })
}
//获取用车审核列表
const getDispatchExamineList = (params) => {
  return axios({
    url: `/api/carorder/examine/dispatch/list`,
    params,
  })
}
//获取车务审核列表
const getCarserviceCheck = (params) => {
  return axios({
    url: '/api/car-service/check/page',
    params,
  })
}

//获取派车列表
const getDispatchList = (params) => {
  return axios({
    url: '/api/carorder/examine/dispatch/list',
    params,
  })
}

//取消派车
const cancleDispatch = (carOrderId) => {
  return axios({
    url: `/api/untask/${carOrderId}`,
    method: 'PUT',
  })
}

//拒绝申请
const rejectDispatch = (data, carOrderId) => {
  return axios({
    url: `/api/carorder/reject/${carOrderId}`,
    method: 'PUT',
    data,
  })
}

//用车单详情
const getOrderDetail = (carOrderId) => {
  return axios({
    url: `/api/carorder/${carOrderId}`,
    method: 'GET',
  })
}

//用车单流程详情
const getRecordDetail = (carOrderId) => {
  return axios({
    url: `/api/carorder/record/${carOrderId}`,
    method: 'GET',
  })
}
//用车单审批通过
const goExamine = (data) => {
  return axios({
    url: '/api/examine/private',
    method: 'POST',
    data,
  })
}
//用车单详情 —— 任务单
const getOrderTask = (carOrderId) => {
  return axios({
    url: `/api/carorder/task/${carOrderId}`,
    method: 'GET',
  })
}

//用车单详情 -- 流程详情
const getOrderRecord = (carOrderId) => {
  return axios({
    url: `/api/carorder/record/${carOrderId}`,
    method: 'GET',
  })
}
//交车确认列表
const getConfirmList = (data) => {
  return axios({
    url: '/api/carorder/confirm/list',
    method: 'POST',
    data,
  })
}

//交车确认详情
const getReportDetail = (carOrderId) => {
  return axios({
    url: `/api/carorder/report/${carOrderId}`,
    method: 'GET',
  })
}

const submitFeeReport = (data) => {
  return axios({
    url: `/api/carorder/confirm`,
    method: 'PUT',
    data,
  })
}

//签到列表
const getSignInList = (data) => {
  return axios({
    url: `/api/logistics/task/list`,
    method: 'POST',
    data,
  })
}

//获取签到详情
const getSignInDetail = (ltId, params) => {
  return axios({
    url: `/api/logistics/task/${ltId}`,
    method: 'GET',
    params,
  })
}

// 用车事由列表
const getCarorderCauseList = () => {
  return axios({
    url: `/api/carorder/cause/list`,
  })
}
// 用车事由列表
const putCarorderCause = (data) => {
  return axios({
    url: `/api/carorder/cause`,
    method: 'PUT',
    data,
  })
}
//初始里程
const startMileage = (params) => {
  return axios({
    url: `/api/order/start/mileage`,
    params,
  })
}
//私车还车
const privateconfirmList = (data) => {
  return axios({
    url: `/api/carorder/confirm/private/list`,
    method: 'POST',
    data,
  })
}
// 默认全部倒出
// 根绝需要进行
export default {
  getDispatchExamineList,
  privateconfirmList,
  startMileage,
  oilPrice,
  getCarorderList,
  applyCarOrder,
  orderRevoke,
  orderexamine,
  directTask,
  registerTask,
  getTaskCars,
  getTaskDrivers,
  getExamineList,
  getCarserviceCheck,
  getDispatchList,
  cancleDispatch,
  rejectDispatch,
  getOrderDetail,
  handleDispatch,
  examineDispatch,
  getRecordDetail,
  getOrderTask,
  getOrderRecord,
  getConfirmList,
  getReportDetail,
  submitFeeReport,
  getSignInList,
  getSignInDetail,
  carServiceCheck,
  getCarorderCauseList,
  putCarorderCause,
  getPrivateList,
  goExamine,
  getPrivateExamineList,
  getPersonPrivateCarList,
}
